export default __webpack_public_path__ + "static/steluta-stici-e7e269b05977a8c5ba097994946c9f3a.png";